import Home from './routes/Home.svelte'
// import MemeCart from './routes/MemeCart.svelte'

const routes = {
  '/': Home
  // '/memecart': MemeCart
}

export default routes
